module.exports = __webpack_public_path__ + "static/media/5_of_spades.018e3d8e.png";